export default __webpack_public_path__ + "static/media/XRP.8157d6ce.png";